import apiService from 'library/api-service';
import { createAsyncThunk } from '@reduxjs/toolkit';

const getProjects = createAsyncThunk('getProjects', async () => {
  const response = await apiService.getProjects();
  const sortedData = [...response.data].sort((a, b) => (a.title || '').localeCompare(b.title || ''));

  return { projects: sortedData };
});

const projectsActions = { getProjects };

export default projectsActions;
